import CodeBlock from '../CodeBlock';

export default function DocsInstallation() {
  return (
    <section data-docs-section="installation" className="text-left mb-16">
      <h2 className="text-2xl font-bold text-white mb-2 group">
        <a href="#installation" className="hover:text-sky-400 transition-colors">Installation</a>
        <span className="ml-2 opacity-0 group-hover:opacity-100 text-gray-600 transition-opacity">#</span>
      </h2>
      <p className="text-gray-400 mb-4">
        Requires Python 3.10+. Core dependencies (numpy, pandas, httpx, pydantic)
        install automatically.
      </p>

      <CodeBlock
        code={`# Core SDK (includes yfinance data provider)
pip install propalgos

# With Plotly visualization
pip install 'propalgos[viz]'

# With JupyterLab notebook support
pip install 'propalgos[notebook]'

# Everything
pip install 'propalgos[viz,notebook]'`}
        language="bash"
      />

      <div className="mt-6 p-4 bg-gray-900/50 border border-gray-800 rounded-lg">
        <p className="text-sm text-gray-400">
          <span className="text-sky-400 font-medium">On-platform auto-config: </span>
          When running inside a PropAlgos-managed notebook, the SDK auto-detects
          platform datasets (e.g. crypto parquets) and configures the data provider
          automatically. No manual setup needed — just <code className="text-gray-300">import propalgos as pa</code>.
        </p>
      </div>
    </section>
  );
}
